import script from "./my-upload-img.vue?vue&type=script&setup=true&lang=js"
export * from "./my-upload-img.vue?vue&type=script&setup=true&lang=js"

import "./my-upload-img.vue?vue&type=style&index=0&id=5ad47e2a&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad47e2a"]])

export default __exports__